"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var HamburgerMenu = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '26' : _b, _c = _a.height, height = _c === void 0 ? '20' : _c, _d = _a.fillColor, fillColor = _d === void 0 ? '#2D2926' : _d, rest = __rest(_a, ["width", "height", "fillColor"]);
    return (react_1["default"].createElement("svg", __assign({ width: width, height: height, viewBox: "0 0 26 20" }, rest),
        react_1["default"].createElement("path", { fill: fillColor, fillRule: "evenodd", d: "M.5 2C.5 1.172 1.172.5 2 .5h22c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5H2C1.172 3.5.5 2.828.5 2zm0 8c0-.828.672-1.5 1.5-1.5h22c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5H2c-.828 0-1.5-.672-1.5-1.5zM2 16.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h22c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5H2z", clipRule: "evenodd" })));
};
exports["default"] = HamburgerMenu;
